<template>
  <div :class='{"file-list-item": true, "file-list-item--has-error": errorMessage}' data-testid="file-list-item">
    <div class="file-details">
      <div class="file-info" @click="onItemClick">
        <div class="file-header">
          <div class="file-header__icon">
            <VcIcon :class="fileIconClass" size="16"/>
          </div>
          <span class="file-header__title">{{fileTitle}}</span>
          <span class="file-header__size">({{fileSize | sizeInMb}})</span>
        </div>
      </div>
      <div v-if="errorMessage" class="file-header__error">{{errorMessage}}</div>
    </div>
    <div v-if="isSignatureRequired"
         class="signature"
         :class='{"max-inline-start": isSignatureRequired}'
         data-testid="file-signature">
      <VcIcon class="icon-sign signature__icon" size="12"></VcIcon>
      <span class="signature__text">{{ $t('common.actions.types.document.signature_required') }}</span>
      <v-divider class="ms-3" vertical />
    </div>
    <div class="file-actions" :class="{'max-inline-start': !isSignatureRequired}">
      <v-btn v-for="action in actions" icon @click="onActionClick(action.type, $event)">
        <VcIcon :class="action.icon" :color="action.color" size="16"></VcIcon>
      </v-btn>
    </div>

  </div>
</template>


<script>


export default {
  name: 'FileListItem',
  props:{
    fileTitle: {
      type: String,
      required: true
    },
    fileUid: {
      type: String,
      required: true
    },
    actions: {
      type: Array,
      required: false
    },
    fileSize: {
      type: Number,
      required: true
    },
    isValid: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      required: false
    },
    isSignatureRequired: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fileIconClass() {
      let iconClass = 'icon-Documents1 file-header__icon--document';
      if (this.isValid) {
        iconClass = 'icon-Completed file-header__icon--success';
      } else if (this.errorMessage) {
        iconClass = 'icon-bounced_thin file-header__icon--error';
      }
      return iconClass;
    }
  },
  filters:{
    sizeInMb(value){
      let  sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (value == 0) return '0 Byte';
      let i = parseInt(Math.floor(Math.log(value) / Math.log(1024)));
      return Math.round(value / Math.pow(1024, i), 2) + ' ' + sizes[i];
    }
  },
  methods: {
    onItemClick(e) {
      if(this.errorMessage) {
        e.stopPropagation()
      }
      else { this.onActionClick("Edit") }
    },
    onActionClick(action, e) {
      if(action === 'Delete') { e.stopPropagation(); }
      this.$emit('file-action-clicked', action, this.fileUid);
    },
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.file-list-item {
  font-size: 13px;
  display: flex;
  max-width: 100%;
  padding: 0 16px;
  align-items: center;
  justify-content: space-between;

  &--has-error {
    background-color: #fafafa;
  }

  .file-info {
    display: flex;
    flex-direction: column;
  }

  .file-details {
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 70%;

    @include md-and-up {
      max-width: max-content;
    }
  }

  .file-actions {
    flex-basis: auto;
    text-align: right;
    white-space: nowrap;
  }

  i.v-icon {
    font-size: 16px;
  }

  &--has-error {
    .file-info {
      margin-top: 15px;
    }
    .file-title {
      color: $grey-color-23
    }
  }

  .file-header {
    white-space: nowrap;
    display: flex;
    align-items: baseline;

    &__icon {
      display: inline-block;
      margin-inline-end: 10px;

      &--document {
        color: $grey-color-22;
      }

      &--error {
        color: $red-color-5;
      }

      &--success {
        color: $green-color-2;
      }
    }

    &__text {
      display: inline-block;
    }

    &__title{
      font-weight: 500;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 60%;

      @include md-and-up {
        max-width: max-content;
      }
    }

    &__size {
      color: $grey-color-22;
      font-size: 12px;
      font-weight: 400;
      white-space: nowrap;
      margin-inline-start: 4px;

      @include md-and-up {
        margin-inline-start: 10px;
      }
    }

    &__error {
      color: $red-color-5;
      font-weight: 400;
      margin-top: 7px;
      margin-inline-start: 25px;
      margin-bottom: 11px;
    }
  }

  .signature {
    display: none;
    white-space: nowrap;
    color: $buttonBlackTextColor;
    max-height: 20px;

    @include md-and-up {
      margin-inline-start: 18px;
      display: flex;
      align-items: center;
    }

    &__icon {
      margin-inline-start: 6px;
    }

    &__text {
      margin-inline-start: 6px;
      font-size: 11px;
      font-weight: 400;
    }
  }

  .max-inline-start {
    margin-inline-start: auto;
  }

}
</style>
